import config from "../assets/config"

export const Config = {
    install(Vue, options) {
        Vue.prototype.$config = function () {
            return config
        }
    }
}